import React from 'react'
import { connect } from 'react-redux'
import { Col, Row } from 'reactstrap'

import PropTypes from 'prop-types'
import InputGroup from '../../common/InputGroup'
import CustomNumberFormat from '../ClickToCall/ClickToCall'
import InputWithCustomFormat from '../ClickToCall/InputWithCustomFormat'
import { EMAIL, OUT_GOING_CALL } from '../../constants/activityTypes'

const ContactInfoTask = ({ contactInfo, openNextStep }) => {
  const handleOpenNextStep = (value, activityType, isCalled) => {
    if (value) {
      openNextStep(activityType, isCalled)
    }
  }
  return (
    <Row className={'mb-3'}>
      <Col md='2' className={'mb-3'}>
        <InputGroup label='Owner Name' disabled value={contactInfo.ownerName} />
      </Col>
      <Col md={4} className={'mb-3'}>
        <InputWithCustomFormat
          name='email'
          label='Email'
          value={contactInfo.email || ''}
          placeholder='Email'
          type='text'
          customIcon='pi-envelope'
          disabled
          activityType={EMAIL}
          onClickFunction={() => {
            contactInfo.email && window.open(`mailto:${contactInfo.email}?subject=Email`)
            handleOpenNextStep(contactInfo.email, EMAIL)
          }}
        />
      </Col>
      <Col md={3} className={'mb-3'}>
        <CustomNumberFormat
          className={'form-control-sm form-control'}
          name='businessPhone'
          label='Business Phone'
          value={contactInfo.businessPhone || ''}
          placeholder='Business Phone'
          type='tel'
          disabled
          format='(999) 999-9999'
          size={10}
          customOnClick={() => handleOpenNextStep(contactInfo.businessPhone, OUT_GOING_CALL, true)}
          makeCallOnTaskComplete
          activityType={OUT_GOING_CALL}
          contactId={contactInfo.id}
        />
      </Col>
      <Col md='3' className={'mb-3'}>
        <CustomNumberFormat
          makeCallOnTaskComplete
          className={'form-control-sm form-control'}
          name='mobilePhone'
          label='Mobile Phone'
          value={contactInfo.mobilePhone || ''}
          placeholder='Mobile Phone'
          type='tel'
          disabled
          format='(999) 999-9999'
          size={10}
          activityType={OUT_GOING_CALL}
          contactId={contactInfo.id}
          customOnClick={() => handleOpenNextStep(contactInfo.mobilePhone, OUT_GOING_CALL, true)}
        />
      </Col>
      <Col md={3} className={'mb-3'}>
        <CustomNumberFormat
          className={'form-control-sm form-control'}
          name='homePhone'
          label='Home Phone'
          value={contactInfo.homePhone || ''}
          placeholder='Home Phone'
          type='tel'
          disabled
          format='(999) 999-9999'
          size={10}
          customOnClick={() => handleOpenNextStep(contactInfo.homePhone, OUT_GOING_CALL, true)}
          makeCallOnTaskComplete
          activityType={OUT_GOING_CALL}
          contactId={contactInfo.id}
        />
      </Col>
      <Col md={3} className={'mb-3'}>
        <CustomNumberFormat
          className={'form-control-sm form-control'}
          name='saferPhone'
          label='Safer Phone'
          value={contactInfo.saferPhone || ''}
          placeholder='Safer Phone'
          type='tel'
          disabled
          format='(999) 999-9999'
          size={10}
          customOnClick={() => handleOpenNextStep(contactInfo.saferPhone, OUT_GOING_CALL, true)}
          makeCallOnTaskComplete
          activityType={OUT_GOING_CALL}
          contactId={contactInfo.id}
        />
      </Col>
      <Col md={3} className={'mb-3'}>
        <CustomNumberFormat
          className={'form-control-sm form-control'}
          name='saferMobilePhone'
          label='Safer Mobile Phone'
          value={contactInfo.saferMobilePhone || ''}
          placeholder='Safer Mobile Phone'
          type='tel'
          disabled
          format='(999) 999-9999'
          size={10}
          customOnClick={() => handleOpenNextStep(contactInfo.saferMobilePhone, OUT_GOING_CALL, true)}
          makeCallOnTaskComplete
          activityType={OUT_GOING_CALL}
          contactId={contactInfo.id}
        />
      </Col>
    </Row>
  )
}

ContactInfoTask.propTypes = {
  contactInfo: PropTypes.object,
}

ContactInfoTask.defaultProps = {
  contactInfo: {},
}

const mapStateToProps = (state) => {
  return {
    contactInfo: state.Task.otherContactData,
  }
}

export default connect(mapStateToProps)(ContactInfoTask)
